import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initErrorReporting } from "./lib/errorReporting";

initErrorReporting();

// ───── Diagnostic logging for chunk / module-import failures ─────
// Logs the exact chunk URL that failed so we can fix the root cause.
window.addEventListener("vite:preloadError", (event: Event) => {
  const e = event as Event & { payload?: { message?: string }; target?: any };
  // eslint-disable-next-line no-console
  console.error("[chunk-error] vite:preloadError", {
    message: e.payload?.message,
    target: (e.target as any)?.src ?? (e.target as any)?.href,
  });
});

window.addEventListener(
  "error",
  (event) => {
    const t = event.target as HTMLScriptElement | HTMLLinkElement | null;
    if (t && (t.tagName === "SCRIPT" || t.tagName === "LINK")) {
      // eslint-disable-next-line no-console
      console.error("[chunk-error] resource failed to load", {
        tag: t.tagName,
        url: (t as HTMLScriptElement).src || (t as HTMLLinkElement).href,
      });
    } else if (event.error?.message?.includes("Importing a module script failed")) {
      // eslint-disable-next-line no-console
      console.error("[chunk-error] dynamic import failed", {
        message: event.message,
        filename: event.filename,
        lineno: event.lineno,
        stack: event.error?.stack,
      });
    }
  },
  true, // capture phase to catch resource errors
);

window.addEventListener("unhandledrejection", (event) => {
  const reason: any = event.reason;
  const msg = reason?.message ?? String(reason);
  if (
    msg.includes("Importing a module script failed") ||
    msg.includes("Failed to fetch dynamically imported module") ||
    msg.includes("ChunkLoadError")
  ) {
    // eslint-disable-next-line no-console
    console.error("[chunk-error] unhandled rejection", {
      message: msg,
      stack: reason?.stack,
    });
  }
});

window.addEventListener("vite:preloadError", (event) => {
  event.preventDefault();

  const reloadKey = "vite-preload-recovered";
  const hasRetried = sessionStorage.getItem(reloadKey) === "true";

  if (!hasRetried) {
    sessionStorage.setItem(reloadKey, "true");
    window.location.reload();
    return;
  }

  sessionStorage.removeItem(reloadKey);
});

window.addEventListener("pageshow", () => {
  sessionStorage.removeItem("vite-preload-recovered");
});

createRoot(document.getElementById("root")!).render(<App />);
